import template from 'lodash/fp/template';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { IntegrationId, } from '@debbie/common/dist/integrations';
import { c, h } from '@debbie/cortex/dist';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import Button from '../Button';
import Disclaimer from '../Disclaimer';
import Modal from '../Modal';
import ActivateIntegration from './ActivateIntegration';
import EConomicSettings from './e-conomic/EConomicSettings';
const Integration = (props) => {
    const creditorActivations = useSelector((state) => state.creditorIntegrationActivations[props.creditorId]);
    const integrationLoader = useSelector((state) => state.integrations[props.id]);
    const activations = useSelector((state) => state.integrationActivations);
    const selectedOwner = useSelector(selectTenantId);
    const lang = useSelector((state) => state.lang);
    const [settingOptions, setSettingOptions] = useState(false);
    const [options, setOptions] = useState();
    useEffect(() => {
        if (h.isNotLoaded(integrationLoader)) {
            c.integrations.get(props.id);
        }
        if (h.isNotLoaded(creditorActivations)) {
            c.integrations.getCreditorActivations(props.creditorId);
        }
        if (h.hasData(creditorActivations)) {
            const activation = creditorActivations.data.find((activation) => activation.integrationId === props.id);
            const activationId = activation != null ? activation.id : '';
            if (activation != null && h.isNotLoaded(activations[activationId])) {
                c.integrations.getActivation(activationId);
            }
        }
    }, [props.id, props.creditorId, creditorActivations]);
    useEffect(() => {
        if (h.hasData(integrationLoader)) {
            setOptions(integrationLoader.data.defaultOptions);
        }
    }, [integrationLoader]);
    if (!h.hasData(integrationLoader) ||
        !h.hasData(creditorActivations) ||
        selectedOwner == null) {
        return null;
    }
    const integration = integrationLoader.data;
    if (props.token != null) {
        return (React.createElement(ActivateIntegration, { tenantId: selectedOwner, creditorId: props.creditorId, id: props.id, token: props.token, options: props.options }));
    }
    const relevantActivation = creditorActivations.data.find((activation) => activation.integrationId === props.id);
    const activationId = relevantActivation != null ? relevantActivation.id : '';
    const activationLoader = activations[activationId];
    if (relevantActivation && !h.hasData(activationLoader)) {
        return null;
    }
    const activation = relevantActivation && h.hasData(activationLoader)
        ? activationLoader.data
        : null;
    return (React.createElement(Wrapper, null,
        React.createElement(Meta, null,
            React.createElement(Logo, { src: integration.logo }),
            React.createElement(MetaText, null,
                React.createElement(Title, null, integration.name),
                React.createElement(Short, null, integration.shortDescription),
                activation != null ? (activation.active ? (React.createElement(Button, { block: true, theme: "dangerous", onClick: () => {
                        c.integrations.deactivate(props.creditorId, activationId);
                    } }, lang.integrations.deactivate)) : (React.createElement(Button, { block: true, onClick: () => {
                        c.integrations.reactivate(props.creditorId, activationId);
                    } }, lang.integrations.reactivate))) : (React.createElement(Button, { block: true, onClick: () => {
                        if (integration.id === IntegrationId.Economic) {
                            setSettingOptions(true);
                        }
                        else {
                            window.location.href = template(integration.link)({
                                redirectUrl: encodeURIComponent(props.redirectUrl),
                            });
                        }
                    } }, lang.integrations.connect)))),
        React.createElement(Description, null,
            React.createElement(DescriptionImagesWrapper, null,
                React.createElement(DescriptionImages, null, integration.images.map((image) => (React.createElement(DescriptionImage, { key: image, src: image }))))),
            React.createElement(DescriptionText, null,
                React.createElement(DescriptionStyles, { dangerouslySetInnerHTML: { __html: integration.description } }))),
        settingOptions ? (React.createElement(Modal, { maxWidth: "400px", header: `${integration.name} ${lang.integrations.integrationOptions}`, onToggle: () => {
                setSettingOptions(false);
            } },
            React.createElement("form", { onSubmit: (e) => {
                    e.preventDefault();
                    window.location.href = template(integration.link)({
                        redirectUrl: encodeURIComponent(props.redirectUrl +
                            '?' +
                            new URLSearchParams({
                                options: JSON.stringify(options),
                            }).toString()),
                    });
                } },
                integration.id === IntegrationId.Economic && options != null ? (React.createElement(EConomicSettings, { options: options, setOptions: setOptions })) : null,
                React.createElement(Disclaimer, null, lang.integrations.notChangable),
                React.createElement(Button, { style: { width: '100%' } }, lang.integrations.connect)))) : null));
};
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: 860px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
const Meta = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1em;
  @media (min-width: 860px) {
    width: calc(30% - 20px);
  }
`;
const MetaText = styled.div ``;
const Logo = styled.img `
  width: 100%;
  height: 64px;
  object-fit: contain;
`;
const Title = styled.h1 `
  margin: 0;
  line-height: 1.5;
  font-size: 1.5em;
`;
const Short = styled.p `
  margin: 0;
  margin-bottom: 20px;
`;
const Description = styled.div `
  width: 100%;
  @media (min-width: 860px) {
    width: 70%;
  }
`;
const DescriptionImagesWrapper = styled.div `
  width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  margin-bottom: 1em;
`;
const DescriptionImages = styled.div `
  display: block;
  width: auto;
`;
const DescriptionImage = styled.img `
  width: 400px;
  max-width: 90%;
  height: 300px;
  object-fit: cover;
  margin-right: 10px;
  border: 1px solid lightgray;
  border-radius: 5px;
`;
const DescriptionText = styled.div `
  width: 100%;
`;
const DescriptionStyles = styled.div `
  h1,
  h2,
  h3 {
    margin: 0;
    margin-bottom: 0.2rem;
    line-height: 1.5;
  }
  h1 {
    font-size: 1.3em;
  }
  h2 {
    font-size: 1.15em;
  }
  h3 {
    font-size: 1em;
  }
  p {
    margin: 0;
    margin-bottom: 0.5rem;
    line-height: 1.5;
  }
`;
export default Integration;
//# sourceMappingURL=Integration.js.map